
const grays = () => {
    let colors = {
        white: "#fff",
        "100": "#f9fafd",
        "200": "#edf2f9",
        "300": "#d8e2ef",
        "400": "#b6c1d2",
        "500": "#9da9bb",
        "600": "#748194",
        "700": "#5e6e82",
        "800": "#4d5969",
        "900": "#344050",
        "1000": "#232e3c",
        "1100": "#0b1727",
        black: "#000",
    };
    if (false) {
        colors = {
            white: "#0e1c2f",
            "100": "#132238",
            "200": "#061325",
            "300": "#344050",
            "400": "#4d5969",
            "500": "#5e6e82",
            "600": "#748194",
            "700": "#9da9bb",
            "800": "#b6c1d2",
            "900": "#d8e2ef",
            "1000": "#edf2f9",
            "1100": "#f9fafd",
            black: "#fff",
        };
    }
    return colors;
};

const themeColors = () => {
    let colors = {
        primary: "#2c7be5",
        secondary: "#748194",
        success: "#00d27a",
        info: "#27bcfd",
        warning: "#f5803e",
        danger: "#e63757",
        light: "#f9fafd",
        dark: "#0b1727",
    };
    if (false) {
        colors.light = grays()["100"];
        colors.dark = grays()["1100"];
    }

    return colors;
};

const pluginSettings = () => {
    let settings = {
        tinymce: {
            theme: "oxide",
        },
        chart: {
            borderColor: "rgba(255, 255, 255, 0.8)",
        },
    };

    if (false) {
        settings.tinymce.theme = "oxide-dark";
        settings.chart.borderColor = themeColors().primary;
    }
    return settings;
};

import i18nRu from '../../../../../storage/app/lang/ru.json';
import i18nEn from '../../../../../storage/app/lang/en.json';
import i18nHe from '../../../../../storage/app/lang/he.json';

export default {
    $window: $(window),
    $document: $(document),
    $html: $('html'),
    $body: $('body'),
    $main: $('main'),
    isRTL: function isRTL() {
        return this.$html.attr('dir') === 'rtl';
    },
    location: window.location,
    nua: navigator.userAgent,
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    },
    offset: function offset(element) {
        const rect = element.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft
        };
    },
    isScrolledIntoViewJS: function isScrolledIntoViewJS(element) {
        const windowHeight = window.innerHeight;
        const elemTop = this.offset(element).top;
        const elemHeight = element.offsetHeight;
        const windowScrollTop = window.scrollY;
        return elemTop <= windowScrollTop + windowHeight && windowScrollTop <= elemTop + elemHeight;
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
        const $el = $(el);
        const windowHeight = this.$window.height();
        const elemTop = $el.offset().top;
        const elemHeight = $el.height();
        const windowScrollTop = this.$window.scrollTop();
        return elemTop <= windowScrollTop + windowHeight && windowScrollTop <= elemTop + elemHeight;
    },
    getCurrentScreenBreakpoint: function getCurrentScreanBreakpoint() {
        const _this = this;

        let currentScreen = '';
        const windowWidth = this.$window.width();
        $.each(this.breakpoints, function (index, value) {
            if (windowWidth >= value) {
                currentScreen = index;
            } else if (windowWidth >= _this.breakpoints.xl) {
                currentScreen = 'xl';
            }
        });
        return {
            currentScreen: currentScreen,
            currentBreakpoint: this.breakpoints[currentScreen]
        };
    },
    grays: grays(),
    settings: pluginSettings(this),
    /**
     * Formats a file size as b, Kb, Mb etc
     * @param { number } size File size in bytes
     * @param { number } dec Number of decimal points to round to
     */
    formatFileSize: function formatFileSize(size, dec)
    {
        if(isNaN(dec)) {
            dec = 2;
        }
        const multiply = Math.pow(10, dec);
        const units = ['b','Kb','Mb','Gb','Tb','Pb'];
        const exponent = Math.floor(Math.log(size)/Math.log(1024));
        return (Math.round(size/Math.pow(1024, exponent) * multiply) / multiply) + units[exponent];
    },

    numEnding: function ($number, $endingArray) {
        let $ending;

        $number = $number % 100;
        if ($number >= 11 && $number <= 19) {
            $ending = $endingArray[2];
        } else {
            let $i = $number % 10;
            switch ($i) {
                case (1):
                    $ending = $endingArray[0];
                    break;
                case (2):
                case (3):
                case (4):
                    $ending = $endingArray[1];
                    break;
                default:
                    $ending = $endingArray[2];
            }
        }
        return $ending;
    },

    /**
     * Clear selected text selection
     */
    clearSelection(){
        if(document.selection && document.selection.empty) {
            document.selection.empty();
        } else if(window.getSelection) {
            let sel = window.getSelection();
            sel.removeAllRanges();
        }
    },
    getDescendantProp(obj, desc) {
        let arr = desc.split(".");
        while(arr.length && (obj = obj[arr.shift()]));
        return obj;
    },
    i18nLangs: {
        en: i18nEn,
        ru: i18nRu,
        he: i18nHe,
    },
    i18n(key){
        function getDescendantProp(obj, desc) {
            let arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            return obj;
        }

        const currentLang = this.currentLang();
        let translate = getDescendantProp(this.i18nLangs, `${currentLang}.${key}`);
        if(translate) return translate;
        return key;
    },
    currentLang()
    {
        return document.documentElement.getAttribute('lang');
    }
}

